import { Button, Stack, Typography } from "@mui/material";

import useBanners from "@app/analytics/hooks/useBanners";
import * as Events from "@app/analytics/tracking/events";
import useAuth from "@app/common/auth/useAuth";
import { Link } from "@app/common/components/Link";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import LINKS from "@app/common/links";
import Config from "@app/config";
import {
  getBrowserName,
  isRssInstalled,
  isRssSupportedBrowser,
} from "@app/utils/browserUtils";

import { NewBadge } from "@rui/FeatureBadge";

const RssUpsellBanner = ({ priority }: { priority: number }) => {
  const { user } = useAuth();

  const [rssUpsellDismissed, setRssUpsellDismissed] = useLocalStorage(
    "rssUpsellDismissed",
    false
  );

  const shouldShow =
    !rssUpsellDismissed &&
    isRssSupportedBrowser() &&
    Boolean(user) &&
    !isRssInstalled();

  const { show } = useBanners({
    id: "rssUpsell",
    priority,
    shouldShow,
  });

  const browserName = getBrowserName();

  const handleDismiss = () => {
    setRssUpsellDismissed(true);
  };

  if (!show) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ minHeight: "60px", bgcolor: "shades.primary.50", p: "10px 16px" }}
      spacing={2}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <NewBadge />
        <Typography variant="bodySecondaryReg">
          <Typography variant="bodySecondaryMed">
            Add Read Smart Scheduler to {browserName}
          </Typography>{" "}
          🎉 Automate finding the best time for your next meeting in Google
          Calendar.
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button onClick={handleDismiss}>Dismiss</Button>
        <Link href={LINKS.MARKETING.RSS}>
          <Button sx={{ height: "40px", whiteSpace: "nowrap" }}>
            Learn More
          </Button>
        </Link>
        <Link href={Config.rss.CHROME_WEB_STORE_URL}>
          <Button
            variant="contained"
            onClick={() =>
              Events.addRss({ browser: browserName!, source: "banner" })
            }
            sx={{ height: "40px", whiteSpace: "nowrap" }}
          >
            Add to {browserName}
          </Button>
        </Link>
      </Stack>
    </Stack>
  );
};

export default RssUpsellBanner;
